var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.70001L9.52 15.18L5.98 11.64C5.79302 11.453 5.53942 11.348 5.275 11.348C5.01057 11.348 4.75698 11.453 4.57 11.64C4.38302 11.827 4.27798 12.0806 4.27798 12.345C4.27798 12.4759 4.30377 12.6056 4.35387 12.7266C4.40398 12.8475 4.47742 12.9574 4.57 13.05L8.81 17.29C9.2 17.68 9.83 17.68 10.22 17.29L19.4 8.11001C19.4932 8.01646 19.5669 7.90535 19.6169 7.78313C19.6669 7.6609 19.6922 7.52998 19.6912 7.39793C19.6903 7.26588 19.6632 7.13532 19.6115 7.01381C19.5598 6.8923 19.4845 6.78224 19.39 6.69001C19.02 6.31001 18.39 6.31001 18 6.70001V6.70001Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.5f16ba45.svg";
export { ForwardRef as ReactComponent };